export default __webpack_public_path__ + "static/media/expl_gradcam_02_DE.4ec5043e.png";